import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { popInOut } from '../../animations';

@Component({
  selector: 'psc-dialog',
  templateUrl: './dialog.component.html',
  animations: [popInOut],
})
export class DialogComponent {
  @Input() title: string;

  @Input() set maxWidthPercentage(value: number) {
    if (value <= 0 || value > 100) {
      return;
    }
    this.maxWidth = value;
  }

  @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    this.closeClicked.emit();
  }

  maxWidth = 90;

  outOfDialogClick(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.closeClicked.emit();
    }
  }
}
